import { createContext, type FC, type PropsWithChildren, type ReactNode, useContext, useState } from "react";
import { useDeviceContext } from "./DeviceContext";
import { useNavigateHomeOnSustainedDisconnect } from "./useNavigateHomeOnSustainedDisconnect";

type ModalContextProps = {
	modal: ReactNode;
	setModal: (modalNode: ReactNode) => void;
};

export const ModalContext = createContext<ModalContextProps>({
	modal: null,
	setModal: (modal) => modal,
});

export const useModalContext = () => useContext(ModalContext);

export const ModalContextProvider: FC<PropsWithChildren> = ({ children }) => {
	const [modal, setModal] = useState<ReactNode>(null);
	const { appConnected } = useDeviceContext();

	useNavigateHomeOnSustainedDisconnect(appConnected);

	return (
		<ModalContext.Provider value={{ modal: modal, setModal: setModal }}>
			{children}
			{modal}
		</ModalContext.Provider>
	);
};
